import React from "react"
import { Flex, Typography } from "antd"
import { PropTypes } from "prop-types"
import XogenieM from "../../assets/images/xogenie_m.png"
import XogenieF from "../../assets/images/xogenie_f.png"
import "./XogenieLandingPage.scss"

const { Text } = Typography

const XogenieLandingPage = ({
  text = "To see this page, select “All Records” in the global record filter and Save. The record you are attempting to access is not available based on the filter criteria you currently have set.",
}) => {
  let [rand, setRand] = React.useState(0)

  React.useEffect(() => {
    setRand(Math.floor(Math.random() * 2))
  }, [])

  return (
    <Flex
      vertical
      justify="center"
      align="center"
    >
      <img
        style={{ height: 549, width: "auto" }}
        src={rand === 1 ? XogenieM : XogenieF}
      />
      {
        <Text
          style={{ textAlign: "center", maxWidth: 600 }}
          strong
        >
          {text}
        </Text>
      }
    </Flex>
  )
}

XogenieLandingPage.propTypes = {
  text: PropTypes.string,
}

export default XogenieLandingPage
